<template>
  <v-form @submit.prevent="addNewCard">
    <v-card>
      <v-card-title class="title">
        Add New Card
      </v-card-title>
      <v-card-text class="pt-3">
        <v-col class="py-0">
          <div id="card-element">
            <!--Stripe.js injects the Card Element-->
          </div>
          <div class="spinner hidden" id="spinner"></div>
          <p id="card-error" class="appRed--text" role="alert"></p>
          <p class="result-message hidden">
            Payment succeeded, see the result in your
            <a href="" target="_blank">Stripe dashboard.</a>
            Refresh the page to pay again.
          </p>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="appRed" text @click="$emit('close')">
          Cancel
        </v-btn>
        <v-btn color="appRed" type="submit">
          Add new card
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { loadStripe } from "@stripe/stripe-js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      stripe: null,
      cardElement: null,
      addCardLoading: false
    };
  },
  computed: {
    ...mapState({
      clientSecret: state => state.stripe.clientSecret
    })
  },
  async mounted() {
    this.stripe = await loadStripe(
      "pk_test_51Ie3SIE2G8bCTlZgz1WttGewqmjtO2IcTO5CmbTlg01B9iXM3czMGBiFy0hbRco3w27GxKRddTc7HQRupdGb25sx00t8ntJfeB"
    );
    let vm = this;
    this.$nextTick(() => {
      var elements = vm.stripe.elements();
      var style = {
        base: {
          color: "#32325d",
          fontFamily: "Arial, sans-serif",
          fontSmoothing: "antialiased",
          fontSize: "16px",
          "::placeholder": {
            color: "#32325d"
          }
        },
        invalid: {
          fontFamily: "Arial, sans-serif",
          color: "#fa755a",
          iconColor: "#fa755a"
        }
      };
      this.cardElement = elements.create("card", {
        style: style
      });
      this.cardElement.mount("#card-element");
    });
  },
  methods: {
    async addNewCard() {
      this.$swal({
        title: "Creating payment Method",
        html: "this will only take a moment...",
        icon: "info",
        onOpen: () => {
          this.$swal.showLoading();
        }
      });
      await this.$store.dispatch("stripe/SETUP_PAYMENT_INTENT");
      const paymentMethod = await this.confirmCardSetup();
      await this.$store.dispatch("stripe/ATTACH_PAYMENT_METHOD", paymentMethod);
      this.$emit("close");
      this.$swal.close();
      this.$swal({
        title: "Success",
        html: "Payment method has been successfully added",
        icon: "info"
      });
    },
    async confirmCardSetup() {
      return await this.stripe
        .confirmCardSetup(this.clientSecret, {
          payment_method: {
            card: this.cardElement
          }
        })
        .then(function(result) {
          if (result.error) {
            throw new Error(result.error);
          } else {
            return result.setupIntent.payment_method;
          }
        });
    }
  }
};
</script>
